import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    const options = [
        {
            label: t('General'),
            selected: ['/company/general'].includes(pathname),
            to: '/company/general',
        },
        {
            label: t('User', { count: 2 }),
            selected: ['/company/users'].includes(pathname),
            to: '/company/users',
        },
    ];

    return options;
};
